/**
 * Skeleton placeholder matching OpportunityCard dimensions. Uses the
 * fursa-skeleton shimmer keyframe defined in index.css for a premium
 * shimmer rather than a flat opacity pulse.
 */
export const OpportunityCardSkeleton = () => (
  <div className="flex h-full flex-col rounded-xl border border-surface-200 bg-white shadow-card">
    <div className="flex items-center justify-between gap-3 border-b border-surface-100 px-5 py-3">
      <div className="h-5 w-24 rounded-full fursa-skeleton" />
      <div className="h-5 w-16 rounded-full fursa-skeleton" />
    </div>
    <div className="flex flex-1 flex-col p-5">
      <div className="flex gap-2">
        <div className="h-3 w-16 rounded fursa-skeleton" />
        <div className="h-3 w-14 rounded fursa-skeleton" />
        <div className="h-3 w-20 rounded fursa-skeleton" />
      </div>
      <div className="mt-3 space-y-2">
        <div className="h-4 w-full rounded fursa-skeleton" />
        <div className="h-4 w-4/5 rounded fursa-skeleton" />
      </div>
      <div className="mt-3 space-y-2">
        <div className="h-3 w-full rounded fursa-skeleton" />
        <div className="h-3 w-11/12 rounded fursa-skeleton" />
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 border-t border-surface-100 pt-4">
        <div className="space-y-1.5">
          <div className="h-2.5 w-16 rounded fursa-skeleton" />
          <div className="h-3 w-20 rounded fursa-skeleton" />
        </div>
        <div className="space-y-1.5">
          <div className="h-2.5 w-16 rounded fursa-skeleton" />
          <div className="h-3 w-20 rounded fursa-skeleton" />
        </div>
      </div>
      <div className="mt-auto flex items-center justify-between border-t border-surface-100 pt-4">
        <div className="h-4 w-24 rounded fursa-skeleton" />
        <div className="h-3 w-10 rounded fursa-skeleton" />
      </div>
    </div>
  </div>
);
